import Vue from 'vue'
import 'overlayscrollbars/css/OverlayScrollbars.css'
import { OverlayScrollbarsPlugin } from 'overlayscrollbars-vue'

Vue.use(OverlayScrollbarsPlugin);